import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import { setAuth } from '../utils/auth';
import './Login.css';

function Login({ onLoginSuccess }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'dark');

  useEffect(() => {
    const check = () => setTheme(localStorage.getItem('theme') || 'dark');
    window.addEventListener('storage', check);
    if (theme === 'light') {
      document.body.classList.add('light-theme');
    } else {
      document.body.classList.remove('light-theme');
    }
    return () => window.removeEventListener('storage', check);
  }, [theme]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await api.post('/auth/login', {
        email,
        password,
      }, { timeout: 15000 });

      const { access_token, user } = response.data;
      setAuth(access_token, user);
      onLoginSuccess();
    } catch (err) {
      console.error('Login error:', err);
      // Auto-recovery: 405 significa che il bundle o il service worker è
      // obsoleto e sta trasformando il POST. Facciamo pulizia e ricarichiamo.
      if (err.response && err.response.status === 405) {
        try {
          if ('serviceWorker' in navigator) {
            const regs = await navigator.serviceWorker.getRegistrations();
            for (const r of regs) { try { await r.unregister(); } catch {} }
          }
          if ('caches' in window) {
            const keys = await caches.keys();
            for (const k of keys) { try { await caches.delete(k); } catch {} }
          }
          try { localStorage.clear(); sessionStorage.clear(); } catch {}
          setError('Ambiente aggiornato: ricaricamento in corso…');
          setTimeout(() => { window.location.reload(true); }, 800);
          return;
        } catch {}
      }
      if (err.response && err.response.status === 401) {
        setError('Email o password non corretti.');
      } else if (err.code === 'ECONNABORTED' || err.message?.includes('timeout')) {
        setError('Il server impiega troppo a rispondere. Riprova tra qualche secondo.');
      } else if (!err.response) {
        setError('Impossibile connettersi al server. Verifica la connessione internet e riprova.');
      } else {
        setError(`Errore del server (${err.response.status}). Riprova tra qualche secondo.`);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-logo" style={{ marginTop: '4px', marginBottom: '12px' }}>
          <img src={theme === 'light' ? "/logo-rubbi-official.jpg" : "/logo-rubbi-clean.png"} alt="Rubbi" />
        </div>

        <form onSubmit={handleSubmit} className="login-form" data-testid="login-form">
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
              placeholder="tua@email.com"
              data-testid="input-email"
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              placeholder="••••••••"
              data-testid="input-password"
            />
          </div>

          {error && (
            <div className="login-error" data-testid="login-error">
              {error}
            </div>
          )}

          <button
            type="submit"
            className="btn-login"
            disabled={loading}
            data-testid="btn-login"
          >
            {loading ? 'Connessione...' : 'Accedi'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
